export enum BreakpointsEnum {
  XS = '(max-width: 576px)',
  SM = '(min-width: 577px) and (max-width: 768px)',
  MD = '(min-width: 769px) and (max-width: 992px)',
  LG = '(min-width: 993px) and (max-width: 1220px)',
  XL = '(min-width: 1221px)',
}
